import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, lastValueFrom } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '@ui-nuvertos/shared';
import { buildQueryString } from '../../utils/http-utils';

@Injectable({
  providedIn: 'root'
})
export class PoService {
  private accountingUrl = environment.accountingUrl;

  constructor(private http: HttpClient, private cookieService: CookieService) {}

  getDefaultPoFormTemplate(): Observable<any> {
    const url = `${this.accountingUrl}/api/v1/vendor-po-form-templates/default`;
    // set cookies
    return this.http.get<any>(url, { withCredentials: true });
  }

  getPurchaseOrder(purchaseOrderId: string, queryParams?: any): Observable<any> {
    const base = `${this.accountingUrl}/api/v1/vendor-pos/${purchaseOrderId}`;
    const url = queryParams ? `${base}${buildQueryString(queryParams)}` : base;
    return this.http.get<any>(url, { withCredentials: true });
  }

  getAllPurchaseOrders(queryParams:any = null): Observable<any> {
    const base = `${this.accountingUrl}/api/v1/vendor-pos/`;
    const url = `${base}${buildQueryString(queryParams, { include: 'vendors' })}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  getPoFormTemplateById(templateId: string): Observable<any> {
    const url = `${this.accountingUrl}/api/v1/vendor-po-form-templates/${templateId}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  updatePurchaseOrder(formData: any, po_id: string): Observable<any> {
    const url = `${this.accountingUrl}/api/v1/vendor-pos/${po_id}`;
    return this.http.put<any>(url, formData, { withCredentials: true });
  }

  createPurchaseOrder(formData: any): Observable<any> {
    const url = `${this.accountingUrl}/api/v1/vendor-pos/`;
    return this.http.post<any>(url, formData, { withCredentials: true });
  }

  deletePurchaseOrder(poId: string | number): Observable<any> {
    const url = `${this.accountingUrl}/api/v1/vendor-pos/${poId}`;
    return this.http.delete<any>(url, { withCredentials: true });
  }

  /**
   * Get audit logs for a purchase order
   * Endpoint: GET /api/v1/vendor-pos/:id/audit-logs
   */
  getAuditLogs(poId: string | number, filterParams?: any): Observable<any> {
    const query = filterParams ? buildQueryString(filterParams) : '';
    const url = `${this.accountingUrl}/api/v1/vendor-pos/${poId}/audit-logs${query}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  /**
   * Get print data for a purchase order (for PDF generation)
   * Endpoint: GET /api/v1/vendor-pos/:id/print-data
   */
  getPrintData(poId: string | number): Observable<any> {
    const url = `${this.accountingUrl}/api/v1/vendor-pos/${poId}/print-data`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  /**
   * Cancel a purchase order
   * Endpoint: PATCH /api/v1/vendor-pos/:id/cancel
   */
  cancelPurchaseOrder(poId: string | number): Observable<any> {
    const url = `${this.accountingUrl}/api/v1/vendor-pos/${poId}/cancel`;
    return this.http.patch<any>(url, {}, { withCredentials: true });
  }
}